import { RouteObject } from "react-router-dom";
import { routes } from "@songtradr-one/shared-common";
import { Portal } from "./Portal";

// LOADER

// WRAPPER

// ROUTE
export const PortalRouteObject: RouteObject = {
  index: true,
  path: routes.portal.base,
  Component: Portal,
};
